import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDrNSoD1LhVGjztjZ0Tysn_nPsGjwrvMqs",
  authDomain: "samplton.eu",
  projectId: "divart-apps",
  storageBucket: "divart-apps.firebasestorage.app",
  messagingSenderId: "742072978260",
  appId: "1:742072978260:web:670c73b68c6a917e9d56c1"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);